var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountsDef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.751,
    height: 20.544,
    viewBox: "0 0 21.751 20.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accounts-_def",
    "data-name": "Accounts- def",
    transform: "translate(-310 -156.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "settings_suggest_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "settings_suggest_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M21.356,11.088l-1.13-2.414-2.414-1.13,2.414-1.13L21.356,4l1.13,2.414L24.9,7.544l-2.414,1.13Zm2.157,7.422-.77-1.618-1.618-.77,1.618-.77.77-1.618.77,1.618,1.618.77-1.618.77ZM10.082,24.544l-.257-2.363a2.845,2.845,0,0,1-1.412-.668l-2,.847-2.26-3.7L6.1,17.38a2.375,2.375,0,0,1,0-1.541L4.15,14.555l2.26-3.7,2,.847a2.845,2.845,0,0,1,1.412-.668l.257-2.363H14.4l.257,2.363a2.845,2.845,0,0,1,1.412.668l2-.847,2.26,3.7-1.952,1.284a2.375,2.375,0,0,1,0,1.541l1.952,1.284-2.26,3.7-2-.847a2.845,2.845,0,0,1-1.412.668L14.4,24.544Zm2.157-4.982a2.855,2.855,0,0,0,2.953-2.953,2.855,2.855,0,0,0-2.953-2.953,2.855,2.855,0,0,0-2.953,2.953,2.855,2.855,0,0,0,2.953,2.953Zm0-1.541a1.362,1.362,0,1,1,1.014-.4A1.374,1.374,0,0,1,12.239,18.022ZM11.366,23h1.746l.205-1.952a5.6,5.6,0,0,0,1.361-.514,4.551,4.551,0,0,0,1.13-.873l1.669.745.847-1.335-1.592-1.13a3.3,3.3,0,0,0,0-2.671l1.592-1.13-.847-1.335-1.669.745a4.551,4.551,0,0,0-1.13-.873,5.605,5.605,0,0,0-1.361-.514l-.205-1.952H11.366l-.205,1.952A5.6,5.6,0,0,0,9.8,12.68a4.551,4.551,0,0,0-1.13.873L7,12.808l-.847,1.335,1.592,1.13a3.3,3.3,0,0,0,0,2.671l-1.592,1.13L7,20.41l1.669-.745a4.551,4.551,0,0,0,1.13.873,5.6,5.6,0,0,0,1.361.514ZM12.239,16.609Z",
    transform: "translate(305.85 152.192)",
    fill: "#9BACB1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsDef);
export default __webpack_public_path__ + "static/media/accounts_def.28339db7f193d0978c5d084c407ef635.svg";
export { ForwardRef as ReactComponent };